import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Layers } from 'lucide-react';

export const HousePicker = ({ houses, onPick, busy }) => {
  const [house, setHouse] = useState(null);
  return (
    <Alert className="border-sky-300 bg-sky-50" data-testid="house-picker">
      <Layers className="h-4 w-4 text-sky-700" />
      <AlertDescription className="space-y-2">
        <p className="text-sm text-sky-950"><strong>This file holds {houses.length} houses.</strong> Choose one to import. Houses are never merged; import the other one separately.</p>
        <div className="space-y-1">
          {houses.map((h) => (
            <label key={h.house} className="flex items-center gap-2 text-sm" data-testid={`house-picker-option-${h.house}`}>
              <input type="radio" name="psb-house" checked={house === h.house} onChange={() => setHouse(h.house)} />
              House {h.house} · {h.name || 'unnamed'}{h.audit_reference ? ` · audit ${h.audit_reference}` : ''}{h.open_date ? ` · from ${h.open_date}` : ''}
            </label>
          ))}
        </div>
        <Button size="sm" disabled={!house || busy} onClick={() => onPick(house)} data-testid="house-picker-decode-btn">Decode house {house || ''}</Button>
      </AlertDescription>
    </Alert>
  );
};
